export interface IntegrationChecklistStep {
  step: number;
  name: string;
  completed: boolean;
  completedAt: string | null;
  detail: string | null;
}

export interface IntegrationTestCaseResult {
  testKey: string;
  name: string;
  description?: string | null;
  passed: boolean;
  detail?: string | null;
  remediation?: string | null;
  runAt?: string | null;
}

export interface IntegrationTestSuiteScenarioResult {
  scenarioName: string;
  description: string;
  passed: boolean;
  detail: string | null;
  remediationGuidance: string | null;
  runAt: string;
}

export interface RunTestSuiteResult {
  results: IntegrationTestSuiteScenarioResult[];
  allPassed: boolean;
  passedCount: number;
  failedCount: number;
}

export interface TestSuiteSummary {
  allPassed: boolean;
  passedCount: number;
  failedCount: number;
}

export interface TestPaymentStageResult {
  id: string;
  label: string;
  completed: boolean;
}

export interface WebhookConfigResult {
  webhookUrl: string;
  pingSuccessful: boolean;
}

export interface IntegrationChecklistData {
  steps: IntegrationChecklistStep[];
  isGoLiveEligible: boolean;
  isLive: boolean;
  completedSteps: number;
  testSuiteResults?: IntegrationTestCaseResult[] | null;
  testPaymentStages?: TestPaymentStageResult[] | null;
}

export type IntegrationChecklistStepAction =
  | 'api-reference-reviewed'
  | 'test-payment'
  | 'webhook-config'
  | 'run-test-suite'
  | 'submit-test-suite';

export const INTEGRATION_STEP_ACTIONS: Record<
  number,
  IntegrationChecklistStepAction
> = {
  1: 'api-reference-reviewed',
  2: 'test-payment',
  3: 'webhook-config',
  4: 'run-test-suite',
};
